import React from 'react';
import { createRoot } from 'react-dom/client';
import Chatbot from '../../index';
import { isPageChatbotEnabled } from './init-chatbot-utils';
import { IChatbotConfig } from '../../interfaces/init-chatbot-interfaces';

const renderChatbot = (
  config: IChatbotConfig,
  disableChatbot: boolean,
  enableChatbotOnAllPages?: boolean,
  chatbotEnabledPages?: string[],
  chatbotDisabledPages?: string[],
) => {
  // Check if chatbot is already initialized
  let chatbotRoot = document?.getElementById('chatbot-root') as HTMLDivElement | null;

  // If already exists, log warning and return
  if (chatbotRoot) {
    return;
  }

  // Create new root element
  chatbotRoot = document?.createElement('div');
  chatbotRoot.id = 'chatbot-root';
  chatbotRoot.className = 'swan';
  document?.body?.appendChild(chatbotRoot);

  const pageURL = window.location.href;

  // Initialize React
  const root = createRoot(chatbotRoot);
  const isPageCBEnabled = isPageChatbotEnabled(config.pageName);
  let enableChatbot = false;
  if (disableChatbot || pageURL.includes('order-help')) {
    enableChatbot = false;
  } else if (enableChatbotOnAllPages) {
    if (chatbotDisabledPages?.includes(config.pageName?.toLowerCase() || '')) {
      enableChatbot = false;
    } else enableChatbot = true;
  } else if (chatbotEnabledPages?.includes(config.pageName?.toLowerCase() || '')) {
    enableChatbot = true;
  } else if (isPageCBEnabled) {
    enableChatbot = true;
  }
  root.render(<Chatbot locale={config.locale?.toLowerCase()} tenant={config.tenant} enableChatbot={enableChatbot} />);
};

export const loadChatbot = (
  config: IChatbotConfig,
  disableChatbot: boolean,
  enableChatbotOnAllPages?: boolean,
  chatbotEnabledPages?: string[],
  chatbotDisabledPages?: string[],
) => {
  /** For studio pages */
  if (window.location.pathname.includes('/studio')) {
    let chatbotInitialized = false;
    // Wait for helpPanelLoaded event before rendering chatbot
    document.addEventListener('helpPanelLoaded', () => {
      renderChatbot(config, disableChatbot, enableChatbotOnAllPages, chatbotEnabledPages, chatbotDisabledPages);
      chatbotInitialized = true;
    });
    // Fallback: render chatbot after 10 seconds if event is not fired
    setTimeout(() => {
      if (!chatbotInitialized) {
        renderChatbot(config, disableChatbot, enableChatbotOnAllPages, chatbotEnabledPages, chatbotDisabledPages);
      }
    }, 10000);
  } else {
    /** Default load chat instantly */
    renderChatbot(config, disableChatbot, enableChatbotOnAllPages, chatbotEnabledPages, chatbotDisabledPages);
  }
};
